export function isStrictNever(x: never): never {
  throw new Error(`Never case reached with unexpected value: ${String(x)}`);
}
